<template>
    <div>
        <head>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta content="Rental management system by Nouveta LTD" name="description" />
            <meta content="Kelvin Njuguna" name="author" />
            <!-- App favicon -->
            <link rel="shortcut icon" href="assets/images/favicon.png">

            <link href="assets/libs/select2/css/select2.min.css" rel="stylesheet" type="text/css" />

            <link href="assets/libs/bootstrap-datepicker/css/bootstrap-datepicker.min.css" rel="stylesheet" type="text/css">
            <link href="assets/libs/spectrum-colorpicker2/spectrum.min.css" rel="stylesheet" type="text/css">
            <link href="assets/libs/bootstrap-timepicker/css/bootstrap-timepicker.min.css" rel="stylesheet" type="text/css">
            <link href="assets/libs/bootstrap-touchspin/jquery.bootstrap-touchspin.min.css" rel="stylesheet" type="text/css" />
            <link rel="stylesheet" href="assets/libs/%40chenfengyuan/datepicker/datepicker.min.css">



            <!-- Bootstrap Css -->
            <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
            <!-- Bootstrap select styling -->
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
            <!-- Icons Css -->
            <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
            <!-- App Css-->
            <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
            <!-- custom Css-->
            <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
        </head>

        <body  data-sidebar="dark">

        <NavigationBar/>

        <!-- Search for bill -->
        <div class="modal fade " id="searchBillModal" data-backdrop="static" data-keyboard="false" tabindex="-1 " role="dialog " aria-labelledby="staticBackdropLabel " aria-hidden="true ">
            <div class="modal-dialog modal-dialog-centered ">
                <div class="modal-content ">
                    <div class="modal-header border-bottom-0 ">
                        <button type="button " class="btn-close d-none" data-dismiss="modal"  aria-label="Close "></button>
                    </div>
                    <div class="modal-body ">
                        <div class="text-center mb-4 ">
                            <div class="avatar-md mx-auto mb-4 ">
                                <div class="avatar-title bg-light rounded-circle text-success h1 ">
                                    <i class="bx bx-receipt "></i>
                                </div>
                            </div>

                            <div class="row justify-content-center ">
                                <div class="col-xl-10 ">
                                    <h4 class="text-primary ">Enter Bill Number To continue

                                    </h4>
                                    <p class="text-muted font-size-14 mb-4 ">
                                        Enter bill No to continue.
                                    </p>

                                    <form>
                                        <div class="row ">
                                            <div class="col-12 ">
                                                <div class="mb-3 ">
                                                    <label for="digit1-input" class="visually-hidden ">Bill No.</label>
                                                    <input  v-model="billNo" type="text" class="form-control form-control-lg text-center two-step " placeholder="Search for Bill">
                                                </div>
                                            </div>
                                        </div>
                                        <button data-dismiss="modal" @click="getBill()" type="button" class="btn btn-success btn-block w-100 ">
                                            <i class="bx bx-search-alt-2 font-size-16 align-middle me-2 "></i>
                                            Search
                                        </button>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Search for bill -->

        <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== -->
         <div id="content" class="content-minimize">

           <div class="page-content">
             <div class="container-fluid">

               <!-- start page title -->
               <div class="row">
                 <div class="col-12">
                   <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                     <h4 class="mb-sm-0 font-size-18">Create Employee Recruitment Request</h4>

                     <div class="page-title-right">
                       <ol class="breadcrumb m-0">
                         <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                         <li class="breadcrumb-item active"><a href="employee-register.html">Employee Approval</a></li>
                         <li class="breadcrumb-item active">{{employee.firstName + ''+ employee.lastName}}</li>
                       </ol>
                     </div>

                   </div>
                 </div>
               </div>
               <!-- end page title -->

               <!-- eTransactions table -->

               <div class="row  justify-content-center align-items-center d-flex">
                 <div class="col-sm-12 col-md-10 col-lg-9">
                   <div class="card">
                     <div class="card-header  bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                       <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                         <h4 class="card-title text-uppercase mb-0 ">
                           Employee recruitment
                         </h4>

                       </div>

                     </div>

                       <div class="card-body">
                         <!-- Personal Details -->
                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Personal Details</p>
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="table-responsive">
                             <table class="table table-striped table-bordered table-hover">
                               <tbody>
                               <tr>
                                 <th>Title:</th>
                                 <td>{{ employee.title }}</td>
                               </tr>
                               <tr>
                                 <th>First Name:</th>
                                 <td>{{ employee.firstName }}</td>
                               </tr>
                               <tr>
                                 <th>Middle Name:</th>
                                 <td>{{ employee.middleName }}</td>
                               </tr>
                               <tr>
                                 <th>Last Name:</th>
                                 <td>{{ employee.lastName }}</td>
                               </tr>
                               <tr>
                                 <th>Date of Birth:</th>
                                 <td>{{ employee.dob }}</td>
                               </tr>
                               <tr>
                                 <th>Email Address:</th>
                                 <td>{{ employee.email }}</td>
                               </tr>
                               <tr>
                                 <th>Phone Number:</th>
                                 <td>{{ employee.phone }}</td>
                               </tr>
                               <tr>
                                 <th>National ID:</th>
                                 <td>{{ employee.nationalId }}</td>
                               </tr>
                               <tr>
                                 <th>Gender:</th>
                                 <td>{{ employee.gender }}</td>
                               </tr>
                               <tr>
                                 <th>Person with Disability:</th>
                                 <td>{{ employee.disabilityStatus }}</td>
                               </tr>
                               <tr>
                                 <th>Postal Code:</th>
                                 <td>{{ employee.postalCode }}</td>
                               </tr>
                               <tr>
                                 <th>Postal Town:</th>
                                 <td>{{ employee.postalTown }}</td>
                               </tr>
                               <tr>
                                 <th>Physical Address:</th>
                                 <td>{{ employee.physicalAddress }}</td>
                               </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>

                         <!-- Extra Details -->
                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Extra Details</p>
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="table-responsive">
                             <table class="table table-striped table-bordered table-hover">
                               <tbody>
                               <tr>
                                 <th>Employment Type:</th>
                                 <td>{{ extraDetails.employmentType }}</td>
                               </tr>
                               <tr>
                                 <th>Education Level:</th>
                                 <td>{{ extraDetails.educationLevel }}</td>
                               </tr>
                               <tr>
                                 <th>Sub County:</th>
                                 <td>{{ extraDetails.subCounty }}</td>
                               </tr>
                               <tr>
                                 <th>Ward:</th>
                                 <td>{{ extraDetails.ward }}</td>
                               </tr>
                               <tr>
                                 <th>Marital Status:</th>
                                 <td>{{ extraDetails.maritalStatus }}</td>
                               </tr>
                               <tr>
                                 <th>Driving License:</th>
                                 <td>{{ extraDetails.drivingLicense }}</td>
                               </tr>
                               <tr>
                                 <th>Blood Group:</th>
                                 <td>{{ extraDetails.bloodGroup }}</td>
                               </tr>
                               <tr>
                                 <th>Spouse Name:</th>
                                 <td>{{ extraDetails.spouseName }}</td>
                               </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>

                         <!-- Employment Details -->
                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Employment Details</p>
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="table-responsive">
                             <table class="table table-striped table-bordered table-hover">
                               <tbody>
                               <tr>
                                 <th>Department:</th>
                                 <td>{{ employmentDetails.department }}</td>
                               </tr>
                               <tr>
                                 <th>Section/Sub-vote:</th>
                                 <td>{{ employmentDetails.section }}</td>
                               </tr>
                               <tr>
                                 <th>Unit/Directorate:</th>
                                 <td>{{ employmentDetails.unit }}</td>
                               </tr>
                               <tr>
                                 <th>Sub Unit:</th>
                                 <td>{{ employmentDetails.subunit }}</td>
                               </tr>
                               <tr>
                                 <th>Designation:</th>
                                 <td>{{ employmentDetails.designation }}</td>
                               </tr>
                               <tr>
                                 <th>Employment Date:</th>
                                 <td>{{ employmentDetails.employmentDate }}</td>
                               </tr>
                               <tr>
                                 <th>Reporting To:</th>
                                 <td>{{ employmentDetails.reportingTo }}</td>
                               </tr>
                               <tr>
                                 <th>Net Salary:</th>
                                 <td>{{ employmentDetails.netSalary }}</td>
                               </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>

                         <!-- Bank Details -->
                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Bank Details</p>
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="table-responsive">
                             <table class="table table-striped table-bordered table-hover">
                               <tbody>
                               <tr>
                                 <th>Account Holder Name:</th>
                                 <td>{{ bankDetails.accountHolder }}</td>
                               </tr>
                               <tr>
                                 <th>Account Number:</th>
                                 <td>{{ bankDetails.accountNumber }}</td>
                               </tr>
                               <tr>
                                 <th>Bank Country:</th>
                                 <td>{{ bankDetails.bankCountry }}</td>
                               </tr>
                               <tr>
                                 <th>Bank Name:</th>
                                 <td>{{ bankDetails.bankName }}</td>
                               </tr>
                               <tr>
                                 <th>Branch Location:</th>
                                 <td>{{ bankDetails.branchLocation }}</td>
                               </tr>
                               <tr>
                                 <th>SHIF Number:</th>
                                 <td>{{ bankDetails.shifNumber }}</td>
                               </tr>
                               <tr>
                                 <th>NSSF Number:</th>
                                 <td>{{ bankDetails.nssfNumber }}</td>
                               </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>

                         <!-- Emergency Contact Details -->
                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Emergency Contact Details</p>
                           </div>
                         </div>
                         <div class="col-12" v-for="(contact, index) in emergencyContacts" :key="'emergency-contact-' + index">
                           <div class="table-responsive">
                             <table class="table table-striped table-bordered table-hover">
                               <tbody>
                               <tr>
                                 <th>Name:</th>
                                 <td>{{ contact.name }}</td>
                               </tr>
                               <tr>
                                 <th>Email:</th>
                                 <td>{{ contact.email }}</td>
                               </tr>
                               <tr>
                                 <th>Phone Number:</th>
                                 <td>{{ contact.phone }}</td>
                               </tr>
                               <tr>
                                 <th>Relationship:</th>
                                 <td>{{ contact.relationship }}</td>
                               </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>

                         <!-- Next of Kin -->
                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Next Of Kin</p>
                           </div>
                         </div>
                         <div class="col-12" v-for="(kin, index) in nextOfKin" :key="'next-of-kin-' + index">
                           <div class="table-responsive">
                             <table class="table table-striped table-bordered table-hover">
                               <tbody>
                               <tr>
                                 <th>Name:</th>
                                 <td>{{ kin.name }}</td>
                               </tr>
                               <tr>
                                 <th>Email:</th>
                                 <td>{{ kin.email }}</td>
                               </tr>
                               <tr>
                                 <th>Phone Number:</th>
                                 <td>{{ kin.phoneNumber }}</td>
                               </tr>
                               <tr>
                                 <th>Relationship:</th>
                                 <td>{{ kin.relationship }}</td>
                               </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>

                         <!-- Employment Documents -->
                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Employment Documents</p>
                           </div>
                         </div>
                         <div class="col-12">
                           <table class="table table-editable-1 align-middle table-edits table-hover">
                             <thead class="table-light">
                             <tr class="text-uppercase table-dark ">
                               <th>#</th>
                               <th>Document</th>
                               <th>File</th>
                               <th>Document Number</th>
                               <th>Valid Till</th>
                               <th></th>
                             </tr>
                             </thead>
                             <tbody>
                             <tr v-for="doc in documents" :key="doc.id" :data-id="doc.id">
                               <td style="width: 80px">{{ doc.id }}.</td>
                               <td>{{ doc.name }}</td>
                               <td>
                                 <a :href="authUrl()+doc.filePath" target="_blank" class="btn btn-link">View {{ doc.name }}</a>
                               </td>
                               <td>{{ doc.documentNumber }}</td>
                               <td>{{ doc.validTill }}</td>
                               <td></td>
                             </tr>
                             </tbody>
                           </table>
                         </div>

                         <div class="col-12">
                           <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                             <p class="fw-semibold mb-0 pb-0 text-uppercase">Submission Details</p>
                           </div>
                         </div>

                         <div class="col-12">
                           <div class="table-responsive table-hover">
                             <table class="table table-striped table-bordered table-hover table-hover">
                               <tbody>
                               <tr>
                                 <th>Submited By</th>
                                 <td>{{ submissionDetails.createdBy }}</td>
                               </tr>
                               <tr>
                                 <th>Date Submited</th>
                                 <td>{{ submissionDetails.dateCreated }}</td>
                               </tr>
                               <tr>
                                 <th>Submiting Officer Role</th>
                                 <td>{{ submissionDetails.submittingOfficerRole }}</td>
                               </tr>
                               </tbody>
                             </table>
                           </div>
                         </div>
                       </div>

                     <div v-if="submissionDetails.approved ==='false'" class="card-body">


                       <div class="card-footer bg-white border-top py-3">
                         <div class="col-12">
                           <button type="button" class="btn btn-success waves-effect waves-light text-uppercase" data-bs-target="#otpConfirmation" data-bs-toggle="modal">
                             <i class="mdi mdi-check-circle-outline font-size-16 align-middle me-2"></i>
                             Approve Recruitment
                           </button>
                           <button type="button" class="btn btn-danger waves-effect text-uppercase mx-3" data-bs-target="#declineApplicationModal" data-bs-toggle="modal" >
                             <i class="mdi mdi-cancel font-size-16 align-middle me-2"></i> Decline
                           </button>

                         </div>
                       </div>
                     </div>
                   </div>
                   <!-- end col -->
                 </div>

                 <!-- end row -->
               </div>
               <!-- container-fluid -->
             </div>
             <!-- End Page-content -->

             <!-- modals go here -->
             <!-- initiating invoice item waiver -->
             <div class="modal fade" id="otpConfirmation" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
               <!-- <div class="modal fade otp-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false"> -->
               <!-- Modal content here -->


               <div class="modal-dialog  w-100 modal-md modal-dialog-centered modal-full">
                 <div class="modal-content w-100 bg-light-blue border-info">
                   <div class="modal-header text-black text-uppercase border-0">
                     <h4 class="modal-title">Confirm Recruitment Approval</h4>
                     <button type="button" class="btn-close d-non" data-bs-dismiss="modal" aria-label="Close"></button>
                   </div>
                   <div v-if="alert.info" class="modal-body waiver-inputers">

                     <div class="otp-entry">
                       <div class="alert alert-info border-info border-2" role="alert">
                         <h4 class="alert-heading text-black text-uppercase">OTP Verification</h4>
                         <p>An OTP (One-Time Password) has been sent to your phone: <strong>+254 7XX XXX 123</strong>. Please enter the OTP to verify and approve the recruitment record. Once approved, the employee will be officially added to the system.</p>

                         <div class="hstack gap-3">
                           <input class="form-control me-auto border-black otp-input" type="text" placeholder="Enter OTP" aria-label="Enter OTP here..." spellcheck="false">
                           <button type="button" class="btn btn-warning text-dark fw-bold text-nowrap text-uppercase">Resend OTP</button>
                         </div>

                         <!-- message sent to employee -->
                         <p class="d-none">"Dear [Employee Name], your recruitment record has been successfully approved. Welcome aboard! You will receive further instructions shortly. If you have any questions, contact HR. Thank you!"
                           <!-- This message is not displayed but will be sent to the employee -->
                         </p>
                       </div>

                       <button @click="approveEmployment()" class="btn btn-success fw-bold mt-4 text-uppercase w-100 d-flex justify-content-center align-items-center text-center otp-btn" title="Approve Recruitment">
                         <div>Confirm Approval</div>
                         <div class="spinner-border text-white ms-2 d-none" style="height: 19px; width: 19px;" role="status">
                           <span class="sr-only">Loading...</span>
                         </div>
                       </button>
                     </div>

                   </div>

                   <div v-if="alert.success" class="modal-body waiver-successful">
                     <!-- show this for successfully approved recruitment -->

                     <div class="p-4 pb-1 category-change-submitted px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                       <div class="flex-shrink-0 align-self-center mb-4">
                         <div class="avatar-md rounded-circle bg-success mini-stat-icon" title="Recruitment Approved">
                                            <span class="avatar-title rounded-circle bg-info">
                                                <i class="bx bx-check-circle fs-1" title="Recruitment Success"></i>
                                            </span>
                         </div>
                       </div>
                       <h4 class="text-uppercase text-dark modal-title fw-bold" title="Recruitment Approved">Recruitment Approved Successfully</h4>
                       <p class="text-center px-5" title="Recruitment Approval Confirmation">
                         The recruitment record has been successfully approved. The employee is now officially added to the system.
                       </p>
                       <div class="w-100 mt-2">
                         <button @click="gotTo('employee-approvals-new')" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-outline-success waves-effect w-100 btn-close-btn-otp text-uppercase fw-bold">
                           Close
                         </button>
                       </div>
                     </div>

                   </div>
                   <!-- show this for a failed attempt -->
                   <div v-if="alert.failed" class="modal-body waiver-fail">
                     <div class="p-4 pb-1  px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                       <div class="flex-shrink-0 align-self-center mb-4">
                         <div class="avatar-md rounded-circle bg-danger mini-stat-icon" title="Recruitment Approval Failed">
                                            <span class="avatar-title rounded-circle bg-danger">
                                                <i class="mdi mdi-alert-circle fs-1" title="Recruitment Failed"></i>
                                            </span>
                         </div>
                       </div>
                       <h4 class="text-uppercase text-danger modal-title fw-bold" title="Recruitment Approval Failed">Recruitment Approval Failed</h4>
                       <p class="text-center px-5" title="Recruitment Failure Reason">
                         Unfortunately, the approval of this recruitment record was unsuccessful. {{message}}
                       </p>

                       <div class="w-100 mt-2">
                         <button type="button" class="btn btn-info waves-effect w-100 btn-close-btn text-uppercase fw-bold">Retry</button>
                         <h6 class="text-center my-2">- OR -</h6>
                         <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-outline-secondary waves-effect w-100 btn-close-btn text-uppercase fw-bold">Close</button>
                       </div>
                     </div>
                   </div>
                 </div>
                 <!-- /.modal-content -->
               </div>

               <!-- /.modal-dialog -->
             </div>
             <!-- invoice item waiver end -->
             <!-- end of modals -->
             <div class="modal fade" id="declineApplicationModal" tabindex="-1" role="dialog" aria-labelledby="declineModalLabel" aria-hidden="true">
               <div class="modal-dialog w-100 modal-md modal-dialog-centered modal-full">
                 <div class="modal-content w-100 bg-light border-danger">
                   <div class="modal-header text-black text-uppercase border-0">
                     <h4 class="modal-title">Confirm Application Decline</h4>
                     <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                   </div>

                   <div v-if="alert.info" class="modal-body waiver-inputers">
                     <div class="otp-entry">
                       <div class="alert alert-danger border-danger border-2" role="alert">
                         <h4 class="alert-heading text-black text-uppercase">OTP Verification</h4>
                         <p>An OTP has been sent to your phone: Please enter the OTP to verify and proceed with declining this application.</p>

                         <div class="hstack gap-3">
                           <input class="form-control me-auto border-black otp-input" type="text" placeholder="Enter OTP" aria-label="Enter OTP here..." spellcheck="false">
                           <button type="button" class="btn btn-warning text-dark fw-bold text-nowrap text-uppercase">Resend OTP</button>
                         </div>
                       </div>

                       <div class="mb-3">
                         <label for="declineReason" class="form-label fw-bold text-danger">Reason for Decline</label>
                         <textarea class="form-control border-danger" id="declineReason" rows="3" placeholder="Enter reason for declining..."></textarea>
                       </div>

                       <button @click="declinedEmployment" class="btn btn-danger fw-bold mt-4 text-uppercase w-100 d-flex justify-content-center align-items-center text-center otp-btn" title="Decline Application">
                         <div>Confirm Decline</div>
                         <div v-if="loaading" class="spinner-border text-white ms-2" style="height: 19px; width: 19px;" role="status">
                           <span class="sr-only">Loading...</span>
                         </div>
                       </button>
                     </div>
                   </div>

                   <!-- Success message for declined application -->
                   <div v-if="alert.success" class="modal-body waiver-succesfull">
                     <div class="p-4 pb-1 d-flex align-items-center justify-content-center flex-column">
                       <div class="flex-shrink-0 align-self-center mb-4">
                         <div class="avatar-md rounded-circle bg-danger mini-stat-icon" title="Application Declined">
                                        <span class="avatar-title rounded-circle bg-danger">
                                            <i class="bx bx-x-circle fs-1" title="Decline Success"></i>
                                        </span>
                         </div>
                       </div>
                       <h4 class="text-uppercase text-dark modal-title fw-bold" title="Application Declined">Application Declined Successfully</h4>
                       <p class="text-center px-5">
                         The application has been successfully declined. The applicant will be notified accordingly.
                       </p>
                       <div class="w-100 mt-2">
                         <button @click="gotTo('employee-approvals-new')" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-outline-danger waves-effect w-100 text-uppercase fw-bold">
                           Close
                         </button>
                       </div>
                     </div>
                   </div>

                   <!-- Failure message for decline attempt -->
                   <div v-if="alert.failed" class="modal-body waiver-fail">
                     <div class="p-4 pb-1 d-flex align-items-center justify-content-center flex-column">
                       <div class="flex-shrink-0 align-self-center mb-4">
                         <div class="avatar-md rounded-circle bg-warning mini-stat-icon" title="Decline Failed">
                                        <span class="avatar-title rounded-circle bg-warning">
                                            <i class="mdi mdi-alert-circle fs-1" title="Decline Failed"></i>
                                        </span>
                         </div>
                       </div>
                       <h4 class="text-uppercase text-warning modal-title fw-bold" title="Decline Failed">Application Decline Failed</h4>
                       <p class="text-center px-5">
                         Unfortunately, the decline attempt was unsuccessful. {{message}}
                       </p>
                       <div class="w-100 mt-2">
                         <button @click="declinedEmployment()" type="button" class="btn btn-info waves-effect w-100 text-uppercase fw-bold">Retry</button>
                         <h6 class="text-center my-2">- OR -</h6>
                         <button @click="gotTo('employee-approvals-new')" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-outline-secondary waves-effect w-100 text-uppercase fw-bold">Close</button>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>



             <footer class="footer ">
               <div class="container-fluid ">
                 <div class="row ">
                   <div class="col-sm-6 ">
                   </div>
                   <div class="col-sm-6 ">
                     <div class="text-sm-end d-sm-block ">

                     </div>
                   </div>
                 </div>
               </div>
             </footer>

         </div>

         </div>

        </body>

    </div>
</template>

<script>
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, execute, getRight } from "@/api";


export default {
  name: "ReceiptsNew",
  computed: {

  },
  components: { NavigationBar },
  data() {
    return {
      message:'',
      alert: {
        success: false,
        info: true,
        failed: false
      },
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,

      employee: {
        title: "",
        firstName: "",
        middleName: "",
        lastName: "",
        dob: "",
        email: "",
        phone: "",
        nationalId: "",
        gender: "",
        disabilityStatus: "",
        disabilityId: "",
        postalCode: "",
        postalTown: "",
        physicalAddress: "",
      },
      extraDetails: {
        employmentType: '',
        educationLevel: '',
        subCounty: '',
        ward: '',
        maritalStatus: '',
        drivingLicense: '',
        bloodGroup: '',
        spouseName: ''
      },
      employmentDetails: {
        department: '',
        section: '',
        unit: '',
        subunit: '',
        designation: '',
        employmentDate: '',
        reportingDate: '',
        reportingTo: '',
        netSalary: '',
      },
      documents: [
        { id: 1, name: 'ID Card', file: '', ownerName: '', validTill: '2019-08-19', isEditing: false },
        { id: 2, name: 'SHIF', file: '', ownerName: '', validTill: '2019-08-19',isEditing: false  },
        { id: 3, name: 'NSSF', file: '', ownerName: '', validTill: '2019-08-19',isEditing: false  },
        { id: 4, name: 'KRA PIN', file: '', ownerName: '', validTill: '2019-08-19',isEditing: false  },
        { id: 5, name: 'Deployment Letter', file: '', ownerName: '', validTill: '2019-08-19' ,isEditing: false },
        { id: 6, name: 'Appointment Letter', file: '', ownerName: '', validTill: '2019-08-19',isEditing: false  },
        { id: 7, name: 'Birth Certificate', file: '', ownerName: '', validTill: '2019-08-19',isEditing: false  },
        { id: 8, name: 'Transfer Letter', file: '', ownerName: '', validTill: '2019-08-19',isEditing: false  }
      ],
      emergencyContacts: [
        {
          name: '',
          email: '',
          phone: '',
          relationship: ''
        }],
      nextOfKin: [
        {
          name: '',
          email: '',
          phoneNumber: '',
          relationship: '',
        },],
      bankDetails: {
        netSalary: '',
        accountHolder: '',
        accountNumber: '',
        bankCountry: '',
        bankName: '',
        branchLocation: '',
        shifNumber: '',
        nssfNumber: ''
      },
      submissionDetails:{

      }
    };
  },
  mounted() {
    this.getEmployeeDataById();
  },
  methods: {
    authUrl() {
      return authUrl
    },
    gotTo(route){
      this.$router.push(route);
    },
    getRight(type) {
      return getRight(type);
    },
    getEmployeeDataById() {
      const data = new FormData();
      data.append("function", "getEmployeeDataById");
      data.append("employeeDataId", sessionStorage.getItem("employeeDataId"));
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              this.employee = res.data.data.employeeData.employeeData
              this.extraDetails = res.data.data.employeeData.extraDetails
              this.employmentDetails = res.data.data.employeeData.employmentDetails
              this.documents = res.data.data.employeeData.documents
              this.emergencyContacts = res.data.data.employeeData.emergencyContacts
              this.nextOfKin = res.data.data.employeeData.nextOfKin
              this.bankDetails = res.data.data.employeeData.bankDetails
              this.submissionDetails = res.data.data.submissionDetails


            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },
    approveEmployment() {
      this.alert.info = true;
      this.alert.success = false;
      this.alert.failed = false;
      const data = new FormData();
      data.append("function", "approveEmployment");
      data.append("employeeDataId", sessionStorage.getItem("employeeDataId"));
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.alert.info = false;
              this.alert.success = true;
              this.alert.failed = false;

            } else {
              this.alert.info = false;
              this.alert.success = false;
              this.alert.failed = true;
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.alert.info = false;
            this.alert.success = false;
            this.alert.failed = true;
            this.message = e.message;
          });
    },
    declinedEmployment() {
      this.alert.info = true;
      this.alert.success = false;
      this.alert.failed = false;
      const data = new FormData();
      data.append("function", "declinedEmployment");
      data.append("employeeDataId", sessionStorage.getItem("employeeDataId"));
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.alert.info = false;
              this.alert.success = true;
              this.alert.failed = false;

            } else {
              this.alert.info = false;
              this.alert.success = false;
              this.alert.failed = true;
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.alert.info = false;
            this.alert.success = false;
            this.alert.failed = true;
            this.message = e.message;
          });
    }
  }
};
</script>


<style scoped>

</style>